import React, { useCallback, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { FaCloudUploadAlt } from 'react-icons/fa'

const ALLOWED_FILE_TYPES = [
  "image/apng",
  "image/avif",
  "image/gif",
  "image/jpeg",
  "image/png",
  "image/svg+xml",
  "image/webp",
  "application/pdf",
  "video/mp4",
  "video/mpeg",
  "audio/x-acc",
  "audio/wav",
  "audio/ogg",
  "audio/mpeg",
  "audio/mpg",
  "audio/mpeg3",
  "audio/mp3"
];
const MAX_FILE_SIZE = 20971520; // 20MB

function LotusDropzone(props) {
  const [errorMessage, setErrorMessage] = useState("");

  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];

    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      setErrorMessage("File tersebut tidak diijinkan untuk dikirim");
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      setErrorMessage("File terlalu besar, maks 20MB");
      return;
    }

    setErrorMessage("");
    props.onAcceptedFiles(acceptedFiles);
  }, []);

  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    onDrop,
    noClick: true,
    noKeyboard: true,
  });

  return (
    <div className="text-center" {...getRootProps()}>
      <div
        className="rounded p-4"
        style={{
          border: `2px dashed ${isDragActive ? '#0d6efd' : '#ced4da'}`,
          backgroundColor: isDragActive ? '#eaf3ff' : '#fafafa',
          transition: 'background-color 0.2s ease, border-color 0.2s ease',
        }}
      >
        <input {...getInputProps()} />
        <FaCloudUploadAlt size={48} color={isDragActive ? '#0d6efd' : '#6c757d'} />
        <h5 className="mt-3 mb-1">Drag &amp; drop file disini</h5>
        <p className="text-muted mb-3">atau</p>
        <button type="button" className="btn btn-primary" onClick={open}>
          Browse File
        </button>

        {errorMessage && <div className="text-danger mt-3">{errorMessage}</div>}
      </div>
    </div>
  )
}

export default LotusDropzone;